export const Accordion = (props) => {
    const { items } = props

    return (
        <div id="accordion" className="accordion" data-aos="fade-up">
            <div className="accordion-list">
                <ul>
                    {items.map(({ title, content }, index) => (
                        <li key={index} data-aos="fade-up" data-aos-delay={(index + 1) * 100}>
                            <i className="bx bx-help-circle icon-help" />{' '}
                            <a
                                className={`title ${index === 0 ? 'collapse' : 'collapsed'}`}
                                data-bs-toggle="collapse"
                                data-bs-target={`#accordion-list-${index + 1}`}
                            >
                                <span>{title}</span>
                                <i className="bx bx-chevron-down icon-show" />
                                <i className="bx bx-chevron-up icon-close" />
                            </a>
                            <div
                                className={`collapse ${index === 0 ? 'show' : ''}`}
                                id={`accordion-list-${index + 1}`}
                                data-bs-parent=".accordion-list"
                            >
                                {content}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
